<template>
  <v-card class="pa-6" outlined>
    <v-tabs v-model="tab" show-arrows>
      <v-tab
        style="border-radius: 8px 0 0 0"
        @click="setMonitoring('monitoring')"
        >Monitoring Stock MID</v-tab
      >
      <v-tab @click="setMonitoring('upload')">Upload MID</v-tab>
      <v-tab style="border-radius: 0 8px 0 0" @click="setMonitoring('fill')"
        >Fill MID</v-tab
      >
    </v-tabs>

    <v-tabs-items class="elevation-2" v-model="tab">
      <v-tab-item><StockMidList :tabContent="tabContent" /></v-tab-item>
      <v-tab-item><StockMidBulk :tabContent="tabContent" /></v-tab-item>
      <v-tab-item><StockMidFill :tabContent="tabContent" /></v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  components: {
    StockMidList: () => import('../../components/detail/StockMidList.vue'),
    StockMidBulk: () => import('../../components/detail/StockMidBulk.vue'),
    StockMidFill: () => import('../../components/detail/StockMidFill.vue'),
  },

  data() {
    return {
      tab: null,
      tabContent: 'monitoring',
    };
  },
  methods: {
    setMonitoring(val) {
      this.tabContent = val;
    },
  },
};
</script>

<style scoped>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
.v-tab {
  border: 1px solid #005e6a;
  color: #005e6a !important;
}
.v-tab--active {
  background-color: #005e6a;
  color: white !important;
}
.v-tabs-slider-wrapper {
  transition: none;
}
</style>
